// AI生视频
import AIPhotographyIndex from '@/views/smartLife/AIPhotography/index'

const jmRoutes = Array.from({ length: 13 }, (_, i) => ({
  path: `AIPhotography/jm/index${i + 1}`,
  name: `AIPhotography/jm/Index${i + 1}`,
  component: () => import(`@/views/smartLife/AIPhotography/jm/index${i + 1}.vue`)
}))

const dbRoutes = Array.from({ length: 14 }, (_, i) => ({
  path: `AIPhotography/db/index${i + 1}`,
  name: `AIPhotography/db/Index${i + 1}`,
  component: () => import(`@/views/smartLife/AIPhotography/db/index${i + 1}.vue`)
}))

export default {
  path: '/smartLife',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'AIPhotography/index',
      name: 'AIPhotographyIndex',
      component: AIPhotographyIndex
    },
    // AI写真，开始
    ...jmRoutes,
    ...dbRoutes
    // AI写真，结束

  ]
}
